import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromInitiative from '../reducers/initiatives.reducer';
import * as fromRoot from '../../../store';
import * as fromAuth from '../../../auth/store';
import { Initiative } from '../../models';
import { findNearest, getDistance } from 'geolib';
import { getGeoLocationPosition } from '../../../geo-location/store';

export const getInitiativeState = createSelector(
  fromFeature.getInitiativesState,
  (state: fromFeature.InitiativeState) => state.initiatives
);

export const getInitiativesEntities = createSelector(getInitiativeState, fromInitiative.getInitiativesEntities);

export const getAllInitiatives = createSelector(getInitiativesEntities, entities => {
  return Object.keys(entities).map(id => entities[+id]);
});

export const getInitiativesLoaded = createSelector(getInitiativeState, fromInitiative.getInitiativesLoaded);
export const getInitiativesLoading = createSelector(getInitiativeState, fromInitiative.getInitiativesLoading);
export const getInitiativesSortOrder = createSelector(getInitiativeState, fromInitiative.getInitiativesSortOrder);
export const getInitiativeSaved = createSelector(getInitiativeState, fromInitiative.getInitiativeSaved);
export const getInitiativeSaving = createSelector(getInitiativeState, fromInitiative.getInitiativeSaving);
export const getInitiativesPage = createSelector(getInitiativeState, fromInitiative.getInitiativesPage);

export const getOrderedInitiatives = createSelector(
  getAllInitiatives,
  getInitiativesPage,
  getInitiativesSortOrder,
  getGeoLocationPosition,
  (initiatives, page, order, position) => {
    if (!position) {
      return initiatives.sort((a, b) => +b.featured - +a.featured || (new Date(b.createdOn) > new Date(a.createdOn) ? 1 : -1));
    }

    switch (order) {
      case 0:
        return initiatives.sort((a, b) => +b.featured - +a.featured || (new Date(b.createdOn) > new Date(a.createdOn) ? 1 : -1));
      case 1:
        return initiatives.sort((a, b) => {
          var p = position as any;
          if (!a.locations?.length || !b.locations?.length) {
            return 0;
          }

          // Sort by the distance of the closest location in a.locations
          var aLoc = findNearest({ latitude: p.coords.latitude, longitude: p.coords.longitude }, a.locations);
          var bLoc = findNearest({ latitude: p.coords.latitude, longitude: p.coords.longitude }, b.locations);

          return (
            getDistance({ latitude: p.coords.latitude, longitude: p.coords.longitude }, aLoc) -
            getDistance({ latitude: p.coords.latitude, longitude: p.coords.longitude }, bLoc)
          );
        });
      default:
        return initiatives.sort((a, b) => +b.featured - +a.featured || (new Date(b.createdOn) > new Date(a.createdOn) ? 1 : -1));
    }
  }
);

export const getMyInitiatives = createSelector(getAllInitiatives, fromAuth.getAuthUser, (initiatives, usr) => {
  return initiatives?.filter(a => a.createdById === usr?.id);
});

export const getSelectedInitiative = createSelector(getInitiativesEntities, fromRoot.getRouterState, (entities, router): Initiative => {
  return router.state && entities[router.state.params?.['initiativeId'] || router.state.data?.['id']];
});

export const getSelectedInitiativeLoaded = createSelector(getSelectedInitiative, (c: Initiative) => {
  return c?.loaded;
});

export const getSelectedInitiativeLoading = createSelector(getSelectedInitiative, (c: Initiative) => {
  return c?.loading;
});
